export const LANGUAGES = [
  {
    code: "en",
    strapiCode: "en",
    label: "English",
    short: "EN",
  },

  {
    code: "ar",
    strapiCode: "ar",
    label: "العربية",
    short: "AR",
  },
];

export const LANGUAGE_CODES = LANGUAGES.map((lang) => lang.code);

export const STRAPI_LOCALE_MAP = {
  en: "en",
  ar: "ar-SA",
};

export const DEFAULT_LOCALE = "en";
